import React from "react";

export default function ColoredLoader({ size = 25, color = "#474747" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width={size}
      height={size}
      style={{
        shapeRendering: "auto",
        display: "block",
        background: "transparent",
      }}
    >
      <g>
        <circle fill={color} r="10" cy="50" cx="84">
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1"
            values="10;0"
            keyTimes="0;1"
            calcMode="spline"
            dur="0.6097560975609756s"
            repeatCount="indefinite"
            attributeName="r"
          />
          <animate
            begin="0s"
            values={color}
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="discrete"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="fill"
          />
        </circle>
        <circle fill={color} r="10" cy="50" cx="16">
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="r"
          />
          <animate
            begin="0s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="cx"
          />
        </circle>
        <circle fill={color} r="10" cy="50" cx="50">
          <animate
            begin="-0.6097560975609756s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="r"
          />
          <animate
            begin="-0.6097560975609756s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="cx"
          />
        </circle>
        <circle fill={color} r="10" cy="50" cx="84">
          <animate
            begin="-1.2195121951219512s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="r"
          />
          <animate
            begin="-1.2195121951219512s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="cx"
          />
        </circle>
        <circle fill={color} r="10" cy="50" cx="16">
          <animate
            begin="-1.8292682926829267s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="0;0;10;10;10"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="r"
          />
          <animate
            begin="-1.8292682926829267s"
            keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
            values="16;16;16;50;84"
            keyTimes="0;0.25;0.5;0.75;1"
            calcMode="spline"
            dur="2.4390243902439024s"
            repeatCount="indefinite"
            attributeName="cx"
          />
        </circle>
        <g />
      </g>
    </svg>
  );
}
